import React from "react"
import {
  FormControl,
  Grid,
  TextField,
} from "@mui/material"
import { Representant } from "../../model/Representant"
import { Trans, useTranslation } from "react-i18next"

interface RepresentantFormProps {
  representant: Representant
  onChange: (updatedRepresentant: Representant) => void
  errorRepresentantNomPlaignant: string
  errorRepresentantNom: string
  errorRepresentantPrenom: string
  errorRepresentantTitre: string
  errorRepresentantCourriel: string
  errorRepresentantTelephone: string
}

const RepresentantForm: React.FC<RepresentantFormProps> = ({
  representant,
  onChange,
  errorRepresentantNomPlaignant,
  errorRepresentantNom,
  errorRepresentantPrenom,
  errorRepresentantTitre,
  errorRepresentantCourriel,
  errorRepresentantTelephone,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    onChange({
      ...representant,
      [name]: value,
    })
  }
  const { t } = useTranslation()

  return (
    <>
      <FormControl fullWidth>
        <TextField
          label={
            <Trans>
              {t("formulaireRepresentant.lblChampEntiteRepresentant")}
            </Trans>
          }
          name="nomRepresentantPlaignant"
          value={representant.nomRepresentantPlaignant}
          onChange={handleChange}
          variant="filled"
          fullWidth
          aria-describedby="error-representant-nom-plaignant"
          style={{ backgroundColor: errorRepresentantNomPlaignant ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
        />
        {errorRepresentantNomPlaignant && (
          <strong
            id="error-representant-nom-plaignant"
            role="alert"
            className="error"
          >
            <Trans>{errorRepresentantNomPlaignant}</Trans>
          </strong>
        )}
      </FormControl>
      <Grid container>
        <Grid item xs={6}>
          <FormControl fullWidth >
            <TextField
              label={<Trans>{t("formulaireContact.lblChampNom")}</Trans>}
              name="nomPersonneAContacter"
              value={representant.nomPersonneAContacter}
              onChange={handleChange}
             variant="filled"
             className="width-98" 
              aria-describedby="error-representant-nom"
              style={{ backgroundColor: errorRepresentantNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorRepresentantNom && (
              <strong
                id="error-representant-nom"
                role="alert"
                className="error"
              >
                <Trans>{errorRepresentantNom}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <TextField
              label={
                <Trans>{t("formulaireContact.lblChampPrenom")}</Trans>
              }
              name="prenomPersonneAContacter"
              value={representant.prenomPersonneAContacter}
              onChange={handleChange}
             variant="filled"
              fullWidth
              aria-describedby="error-representant-prenom"
              style={{ backgroundColor: errorRepresentantPrenom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorRepresentantPrenom && (
              <strong
                id="error-representant-prenom"
                role="alert"
                className="error"
              >
                <Trans>{errorRepresentantPrenom}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
      </Grid>
      <FormControl fullWidth >
        <TextField
          label={<Trans>{t("formulaireContact.lblChampTitre")}</Trans>}
          name="titrePersonneAContacter"
          value={representant.titrePersonneAContacter}
          onChange={handleChange}
         variant="filled"
          fullWidth
          aria-describedby="error-representant-titre"
          style={{ backgroundColor: errorRepresentantTitre ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
        />
        {errorRepresentantTitre && (
          <strong id="error-representant-titre" role="alert" className="error">
            <Trans>{errorRepresentantTitre}</Trans>
          </strong>
        )}
      </FormControl>
      <Grid container>
        <Grid item xs={6}>
          <FormControl className="width-98" >
            <TextField
              label={
                <Trans>{t("formulaireContact.lblChampCourriel")}</Trans>
              }
              name="courrielPersonneAContacter"
              value={representant.courrielPersonneAContacter}
              onChange={handleChange}
             variant="filled"
              fullWidth
              aria-describedby="error-representant-courriel"
              style={{ backgroundColor: errorRepresentantCourriel ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorRepresentantCourriel && (
              <strong
                id="error-representant-courriel"
                role="alert"
                className="error"
              >
                <Trans>{errorRepresentantCourriel}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <TextField
              label={
                <Trans>{t("formulaireContact.lblChampTelephone")}</Trans>
              }
              name="telephonePersonneAContacter"
              value={representant.telephonePersonneAContacter}
              onChange={handleChange}
             variant="filled"
              fullWidth
              aria-describedby="error-representant-telephone"
              style={{ backgroundColor: errorRepresentantTelephone ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
            />
            {errorRepresentantTelephone && (
              <strong
                id="error-representant-telephone"
                role="alert"
                className="error"
              >
                <Trans>{errorRepresentantTelephone}</Trans>
              </strong>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}

export default RepresentantForm